package com.castly.admin.ui

import androidx.compose.runtime.*
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.BorderRadius
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.Typography
import com.castly.admin.ui.theme.themeTransition
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Modal(
    title: String,
    isOpen: Boolean,
    onClose: () -> Unit,
    maxWidth: CSSpxValue = 800.px,
    content: @Composable () -> Unit
) {
    if (!isOpen) return

    val colors = AppTheme.colors

    // Backdrop and modal container
    Div({
        onClick { onClose() }
        style {
            property("position", "fixed")
            property("top", "0")
            property("left", "0")
            property("right", "0")
            property("bottom", "0")
            property("z-index", "9999")
            backgroundColor(rgba(0, 0, 0, 0.5))
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            padding(Spacing.xl)
            property("overflow-y", "auto")
        }
    }) {
        // Modal content
        Div({
            onClick { event -> event.stopPropagation() }
            style {
                backgroundColor(Color(colors.surface))
                borderRadius(BorderRadius.lg)
                property("box-shadow", "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)")
                maxWidth(maxWidth)
                width(100.percent)
                property("max-height", "90vh")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                border(1.px, LineStyle.Solid, Color(colors.border))
                themeTransition()
            }
        }) {
            // Modal header
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    padding(Spacing.xl, Spacing.xxl)
                    property("border-bottom", "1px solid ${colors.border}")
                }
            }) {
                H2({
                    style {
                        margin(0.px)
                        fontSize(Typography.xl)
                        color(Color(colors.text))
                    }
                }) {
                    Text(title)
                }

                Button({
                    onClick { onClose() }
                    style {
                        backgroundColor(Color.transparent)
                        border(0.px)
                        fontSize(Typography.xxl)
                        cursor("pointer")
                        color(Color(colors.textMuted))
                        padding(0.px)
                        width(32.px)
                        height(32.px)
                        display(DisplayStyle.Flex)
                        alignItems(AlignItems.Center)
                        justifyContent(JustifyContent.Center)
                        borderRadius(BorderRadius.sm)
                        property("transition", "background-color 0.2s")
                    }
                }) {
                    Text("\u00D7")
                }
            }

            // Modal body - scrollable
            Div({
                style {
                    padding(Spacing.xxl)
                    property("overflow-y", "auto")
                    property("flex", "1")
                    color(Color(colors.text))
                }
            }) {
                content()
            }
        }
    }
}
